module.exports = __webpack_public_path__ + "img/weddingRingsFacettedConnections-emotion-02.e83266b.jpg";